export default function ContactFormSection() {
    const contactInfo = {
      address: "5th floor, 11A Oko Awo Street, Victoria Island Lagos.",
      email: "info@alphadenexplorationandproduction.com",
      phone: "+234 902 220 3488",
    };
  
    return (
      <section className="py-20 lg:py-32 bg-white overflow-x-hidden">
        <div className="max-w-[1160px] mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-[155px]">
            {/* Left side - Contact Form */}
            <div>
              <form className="space-y-6 px-6 lg:px-0">
                {/* Full Name and Email - Side by side */}
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="fullName" className="block text-sm font-medium text-[#374151] mb-2">
                      Full Name <span className="text-red-600">*</span>
                    </label>
                    <input
                      type="text"
                      id="fullName"
                      name="fullName"
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:border-transparent outline-none transition"
                    />
                  </div>
  
                  <div>
                    <label htmlFor="email" className="block text-sm font-medium ext-[#374151 mb-2">
                      Email Address <span className="text-red-600">*</span>
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:border-transparent outline-none transition"
                    />
                  </div>
                </div>
  
                {/* Company Name and Phone Number - Side by side */}
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="companyName" className="block text-sm font-medium ext-[#374151 mb-2">
                      Company Name
                    </label>
                    <input
                      type="text"
                      id="companyName"
                      name="companyName"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:border-transparent outline-none transition"
                    />
                  </div>
  
                  <div>
                    <label htmlFor="phoneNumber" className="block text-sm font-medium ext-[#374151 mb-2">
                      Phone Number
                    </label>
                    <input
                      type="tel"
                      id="phoneNumber"
                      name="phoneNumber"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:border-transparent outline-none transition"
                    />
                  </div>
                </div>
  
                {/* Service Interest - Dropdown */}
                <div>
                  <label htmlFor="serviceInterest" className="block text-sm font-medium ext-[#374151 mb-2">
                    Service Interest
                  </label>
                  <select
                    id="serviceInterest"
                    name="serviceInterest"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:border-transparent outline-none transition appearance-none bg-white"
                    defaultValue=""
                  >
                    <option value="" disabled>Select a service</option>
                    <option value="drilling">Drilling Services</option>
                    <option value="equipment">Equipment Rental</option>
                    <option value="consulting">Consulting</option>
                    <option value="other">Other</option>
                  </select>
                </div>
  
                {/* Message - Textarea */}
                <div>
                  <label htmlFor="message" className="block text-sm font-medium ext-[#374151 mb-2">
                    Message <span className="text-red-600">*</span>
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    rows={6}
                    required
                    maxLength={500}
                    placeholder="Tell us about your project requirements..."
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:border-transparent outline-none transition resize-none"
                  ></textarea>
                  <p className="text-sm text-gray-500 mt-2">0/500 characters</p>
                </div>
  
                {/* Submit Button */}
                <button
                  type="submit"
                  className="w-full bg-[#00458F] hover:bg-blue-800 text-white font-semibold py-3 px-6 rounded-lg transition-colors"
                >
                  Send Message
                </button>
              </form>
            </div>
  
            {/* Right side - Contact Information */}
            <div className="space-y-10 p-4 min-w-0 overflow-hidden">
              {/* Address */}
              <div className="flex gap-6 min-w-0">
                <div className="w-[56px] h-[56px] shrink-0 bg-[#00458F14] rounded-[12px] flex items-center justify-center ">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16 2C13.0836 2.00331 10.2877 3.1633 8.22548 5.22548C6.1633 7.28766 5.00331 10.0836 5 13C5 22.4125 15 29.5212 15.4263 29.8188C15.5944 29.9365 15.7947 29.9997 16 29.9997C16.2053 29.9997 16.4056 29.9365 16.5737 29.8188C17 29.5212 27 22.4125 27 13C26.9967 10.0836 25.8367 7.28766 23.7745 5.22548C21.7123 3.1633 18.9164 2.00331 16 2ZM16 9C16.7911 9 17.5645 9.2346 18.2223 9.67412C18.8801 10.1136 19.3928 10.7384 19.6955 11.4693C19.9983 12.2002 20.0775 13.0044 19.9231 13.7804C19.7688 14.5563 19.3878 15.269 18.8284 15.8284C18.269 16.3878 17.5563 16.7688 16.7804 16.9231C16.0044 17.0775 15.2002 16.9983 14.4693 16.6955C13.7384 16.3928 13.1136 15.8801 12.6741 15.2223C12.2346 14.5645 12 13.7911 12 13C12 11.9391 12.4214 10.9217 13.1716 10.1716C13.9217 9.42143 14.9391 9 16 9Z" fill="#00458F"/>
                    </svg>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-[#001409] mb-2">Address</h3>
                  <p className="text-sm text-[#394940]">{contactInfo.address}</p>
                </div>
              </div>
  
              {/* Email */}
              <div className="flex gap-6">
                <div className="w-[56px] h-[56px] bg-[#00458F14] rounded-[12px] flex items-center justify-center">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M28 6H4C3.73478 6 3.48043 6.10536 3.29289 6.29289C3.10536 6.48043 3 6.73478 3 7V24C3 24.5304 3.21071 25.0391 3.58579 25.4142C3.96086 25.7893 4.46957 26 5 26H27C27.5304 26 28.0391 25.7893 28.4142 25.4142C28.7893 25.0391 29 24.5304 29 24V7C29 6.73478 28.8946 6.48043 28.7071 6.29289C28.5196 6.10536 28.2652 6 28 6ZM12.3387 16L5 22.7262V9.27375L12.3387 16ZM13.8188 17.3563L15.3188 18.7375C15.5032 18.9069 15.7446 19.0008 15.995 19.0008C16.2454 19.0008 16.4868 18.9069 16.6712 18.7375L18.1712 17.3563L25.4212 24H6.57125L13.8188 17.3563ZM19.6612 16L27 9.2725V22.7275L19.6612 16Z" fill="#00458F"/>
                </svg>

                </div>
                <div className="min-w-0">
                  <h3 className="text-lg font-semibold text-[#001409] mb-2">Email</h3>
                  <p className="text-sm text-[#394940] break-all">{contactInfo.email}</p>
                </div>
              </div>
  
              {/* Phone */}
              <div className="flex gap-6 min-w-0">
                <div className="w-[56px] h-[56px] shrink-0 bg-[#00458F14] rounded-[12px] flex items-center justify-center">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M28.985 21.885C28.7621 23.5788 27.9303 25.1335 26.6449 26.2588C25.3595 27.3841 23.7084 28.0031 22 28C12.075 28 4.00001 19.925 4.00001 9.99999C3.99695 8.2916 4.61587 6.64052 5.74118 5.35511C6.86649 4.0697 8.42122 3.23787 10.115 3.01499C10.5433 2.96269 10.9771 3.05032 11.3515 3.26479C11.7259 3.47926 12.0209 3.80907 12.1925 4.20499L14.8325 10.0987V10.1137C14.9639 10.4168 15.0181 10.7477 14.9904 11.0768C14.9627 11.406 14.8539 11.7231 14.6738 12C14.6513 12.0337 14.6275 12.065 14.6025 12.0962L12 15.1812C12.9363 17.0837 14.9263 19.0562 16.8538 19.995L19.8963 17.4062C19.9261 17.3811 19.9574 17.3578 19.99 17.3362C20.2666 17.1517 20.5849 17.0391 20.916 17.0086C21.2471 16.978 21.5806 17.0305 21.8863 17.1612L21.9025 17.1687L27.7913 19.8075C28.1879 19.9785 28.5185 20.2732 28.7337 20.6477C28.9489 21.0222 29.037 21.4562 28.985 21.885Z" fill="#00458F"/>
                    </svg>
                </div>
                <div className="min-w-0">
                  <h3 className="text-lg font-semibold text-[#001409] mb-2">Phone number</h3>
                  <p className="text-sm text-[#394940] break-words">{contactInfo.phone}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }